import { useEffect, Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Lenis from "lenis";
import Landing from "@/pages/Landing";
import EditorPage from "@/pages/Editor";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-obsidian px-6 text-center">
                    <p className="font-display text-3xl font-black">Something glitched</p>
                    <p className="text-slate-400">Reload the page to get back to editing.</p>
                    <button
                        data-testid="error-reload-button"
                        onClick={() => window.location.reload()}
                        className="rounded-full bg-amberx px-6 py-3 font-display font-bold text-obsidian"
                    >
                        Reload Deoeditz
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

function ScrollManager() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    }, [pathname]);
    return null;
}

export default function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <ScrollManager />
                <div className="grain-overlay" aria-hidden="true" />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/editor" element={<EditorPage />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                <Toaster position="top-center" theme="dark" />
            </BrowserRouter>
        </ErrorBoundary>
    );
}
